module.exports = __webpack_public_path__ + "c9a16507f492dfcc0c69f449c38c3241.png";